export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";